module.exports = __webpack_public_path__ + "img/beaver2.c753ed1c.png";